module.exports = __webpack_public_path__ + "img/rangeLabel.f82bfc85.svg";